import { createApp } from 'vue'
import blogSlider from './blog-slider.vue';
import {getPropsData} from '../../utils/helper-functions'

export default () => {
  document.querySelectorAll('blog-slider').forEach((el) => {
    const propData = getPropsData(el.closest('section').nextElementSibling);
    createApp(blogSlider, {data:propData}).mount(el);
  })
}